import React from "react";
import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons";
import { useTranslation } from "react-i18next";

import { isIdentityDocumentExpired } from "../helpers/clientIdentity";

const ClientIdentityExpiredAlert = ({ form, ...props }) => {
  const { t } = useTranslation();
  if (!isIdentityDocumentExpired(form?.values)) return null;

  return (
    <Alert
      icon={<IconAlertCircle size={16} />}
      color="red"
      mb="md"
      title={t("ID expired")}
      {...props}
    >
      {t("This client's identity document has expired.")}
    </Alert>
  );
};

export default ClientIdentityExpiredAlert;
